import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { retrieveFundFromOriginOptions } from './api.funds.options';

import type { FundFromOriginResponse } from './api.funds.types';

export const useGetFundFromOrigin =
  (): UseQueryResult<FundFromOriginResponse> => {
    return useQuery(retrieveFundFromOriginOptions);
  };
